var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticClass:"g-map",attrs:{"center":_vm.center,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }